module.exports = __webpack_public_path__ + "static/media/YB5M02_0.c221c519.jpg";